import full_page_children from './full_page'
// import main_children from './main'

const routes = [
    // {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
    // path: '',
    // component: () => import('@/views/Home.vue')
    // children: [
    //     // =============================================================================
    //     // Theme Routes
    //     // =============================================================================
    //     {
    //         path: '/',
    //         name: 'home',
    //         meta: {
    //             require_auth: false, // Only show when logged in or logged out. null shows always.
    //             require_role: [], // Require ONE of these roles for access
    //             title: 'Home', // Display name for use in side menu, etc
    //             icon: 'HomeIcon', // The feather icon to be used when identifying this page
    //             slug: 'home', // Used to identify active route when in child routers
    //             searchable: true, // Allow search to find this route
    //             param_restrictions: {
    //                 // Restricts the options for url parameters
    //                 // action: [] // Restrict param 'action' to the specified routes
    //             }
    //         },
    //         component: () => import('@/views/Home.vue')
    //     },
    //     ...main_children
    // ]
    // },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
        path: '',
        component: () => import('@/layouts/full-page/FullPage.vue'),
        children: full_page_children
    },
    // Redirect to 404 page, if no match found
    {
        path: '*',
        redirect: { name: '404' }
    }
]

export default routes
